import BankingIntegrations from '@/models/Settings/Institutions/Integrations/BankingIntegrations';

export default (bankingIntegration: BankingIntegrations) => {
    let returnVal = "Undefined";
    switch (bankingIntegration) {
        case BankingIntegrations.ClearBank:
            returnVal = "ClearBank"
            break;
        case BankingIntegrations.Swisscom:
            returnVal = "Swisscom"
            break;
    }
    return returnVal;
}